import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { thumbnailOverflowWrapper } from '../../../Thumbnail/Thumbnail.tokens';
import { leavingTransition, LeavingVariant, leavingVariants, presentTransition } from '../../ThumbnailStack.motion';
import { tokens } from '../../tokens';

const itemBase = css`
    --yat_thumbnail-stack-item-z-index: ${tokens.zindex.item.bottom};
    --yat_thumbnail-stack-item-size: ${tokens.item.size.bottom}px;
    --yat_thumbnail-stack-item-shadow-size: ${tokens.item.shadowSize.bottom}px;

    position: relative;
    z-index: var(--yat_thumbnail-stack-item-z-index);
    display: grid;
    width: var(--yat_thumbnail-stack-item-size);
    height: var(--yat_thumbnail-stack-item-size);

    &:nth-child(1) {
        --yat_thumbnail-stack-item-z-index: ${tokens.zindex.item.top};
        --yat_thumbnail-stack-item-size: ${tokens.item.size.top}px;
        --yat_thumbnail-stack-item-shadow-size: ${tokens.item.shadowSize.top}px;
    }

    &:nth-child(2) {
        --yat_thumbnail-stack-item-z-index: ${tokens.zindex.item.middle};
        --yat_thumbnail-stack-item-size: ${tokens.item.size.middle}px;
        --yat_thumbnail-stack-item-shadow-size: ${tokens.item.shadowSize.middle}px;
    }

    &:nth-child(1n + 4) {
        // In case more than 3 items get rendered to the list.
        --yat_thumbnail-stack-item-z-index: ${tokens.zindex.item.base};
        position: absolute;
        right: 0;
    }
`;

export const PresentItem = styled(motion.li).attrs({
    transition: presentTransition,
    layout: true,
})`
    ${itemBase};
`;

export const LeavingItem = styled(motion.li).attrs({
    variants: leavingVariants,
    initial: LeavingVariant.Initial,
    // Technically, the component does not perform an `exit`
    // animation. The "entrance" animation is that of the
    // item "exiting". Upon completion, we immediately remove
    // the item from the DOM.
    animate: LeavingVariant.Leave,
    transition: leavingTransition,
})`
    ${itemBase};
`;

export const ThumbnailWrapper = styled.div`
    ${thumbnailOverflowWrapper(tokens.item.radius)};
    // prettier-ignore
    box-shadow:
        var(--yat_thumbnail-stack-item-shadow-size)
        var(--yat_thumbnail-stack-item-shadow-size)
        var(--yat_thumbnail-stack-item-shadow-size)
        rgba(0, 0, 0, 0.2);
`;
